export enum ActionReasonEntityEnum {
  Operation = 'Operation',
  Delivery = 'Delivery',
  OmsOrder = 'OmsOrder',
  Schedule = 'Schedule'
}
